import ApiService from '@/services/apiService'
import { helpers } from "vuelidate/lib/validators"

const emailAvailable = async function (value) {
	let payload = { email: value }
	try {
		await ApiService.post('users/check-email', payload)
		return true
	} catch (error) {
		if (error.response.status === 422) return false
	}
}

const passwordLength = helpers.withParams(
	{ message: 'Password must be at least 8 characters' },
	(value) => helpers.len(value) >= 8
)

const phoneLength = helpers.withParams(
	{ message: 'Must be between 8 and 15 digits' },
	(value) => {
		let valueWithoutSpaces = value.replace(/\s/g, '')
		return (
			helpers.len(valueWithoutSpaces) >= 8 &&
			helpers.len(valueWithoutSpaces) <= 15
		)
	}
)

export { emailAvailable, passwordLength, phoneLength }
